<template>
  <div
    class="customizer d-none d-md-block"
    :class="{'open': isCustomizerOpen}"
  >
    <!-- Toggler -->
    <b-link
      class="customizer-toggle d-flex align-items-center justify-content-center"
      @click="isCustomizerOpen = !isCustomizerOpen"
    >
      <feather-icon
        icon="SettingsIcon"
        size="15"
        class="spinner"
      />
    </b-link>
    <!-- /Toggler -->

    <!-- Header -->
    <div class="customizer-section d-flex justify-content-between align-items-center">
      <div>
        <h4 class="text-uppercase mb-0">
          Dashboard
        </h4>
        <small>Yapılandırma</small>
      </div>
      <feather-icon
        icon="XIcon"
        size="18"
        class="cursor-pointer"
        @click="isCustomizerOpen = !isCustomizerOpen"
      />
    </div>
    <!-- Header -->

    <vue-perfect-scrollbar
      :settings="perfectScrollbarSettings"
      class="ps-customizer-area scroll-area"
    >
      <div class="customizer-section">
        <b-form-group
          label="Otomatik Veri Güncelleme"
        >
          <v-select
            v-model="configData.refreshTime"
            :clearable="false"
            label="title"
            :options="refreshTimes"
            :reduce="option => option.value"
            @input="setCountDown"
          />
        </b-form-group>
      </div>
      <div class="customizer-section">
        <b-form-group label="Önbellek Bilgisi">
          <b-list-group class="mb-2">
            <b-list-group-item
              v-for="(item,key) in cacheInfo"
              :key="key"
            >
              <div class="font-weight-bold">
                {{ item.name }}
              </div>
              <template v-if="moment(item.time).isValid()">
                <div class="text-danger font-small-2">
                  {{ moment().diff(item.time,'minutes') }} dakika önce
                </div>
              </template>
              <template v-else>
                <div class="text-danger font-small-2">
                  {{ item.time }}
                </div>
              </template>
            </b-list-group-item>
          </b-list-group>
          <b-button
            variant="primary"
            block
            @click="refreshData"
          >
            Tüm Veriyi Güncelle
          </b-button>
        </b-form-group>
      </div>
    </vue-perfect-scrollbar>
  </div>
</template>

<script>
import {
  BLink, BFormGroup, BButton, BListGroup, BListGroupItem,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import useAppCustomizer from './useAppCustomizer'

export default {
  components: {
    // BSV
    BLink,
    BFormGroup,
    BButton,
    BListGroup,
    BListGroupItem,
    // 3rd party
    vSelect,
    VuePerfectScrollbar,
  },
  props: {
    cacheInfo: {
      type: Array,
      default: null,
    },
    refreshData: {
      type: Function,
      required: true,
    },
    startCountdown: {
      type: Function,
      required: true,
    },
  },
  computed: {
    configData() {
      return this.$store.getters['liveDashboardConfig/configData']
    },
    refreshTimes() {
      return this.$store.getters['liveDashboardConfig/refreshTimes']
    },
  },
  methods: {
    setCountDown() {
      this.configData.countDown = this.configData.refreshTime
      this.startCountdown()
    },
  },
  setup() {
    const {
      // Vertical Menu
      isVerticalMenuCollapsed,

      // Customizer
      isCustomizerOpen,

      // Skin
      skin,
      skinOptions,

      // Content Width
      contentWidth,
      contentWidthOptions,

      // RTL
      isRTL,

      // routerTransition
      routerTransition,
      routerTransitionOptions,

      // Layout Type
      layoutType,
      layoutTypeOptions,

      // NavMenu Hidden
      isNavMenuHidden,

      // Navbar
      navbarColors,
      navbarTypes,
      navbarBackgroundColor,
      navbarType,

      // Footer
      footerTypes,
      footerType,
    } = useAppCustomizer()

    if (layoutType.value === 'horizontal') {
      // Remove semi-dark skin option in horizontal layout
      const skinSemiDarkIndex = skinOptions.findIndex(s => s.value === 'semi-dark')
      delete skinOptions[skinSemiDarkIndex]

      // Remove menu hidden radio in horizontal layout => As we already have switch for it
      const menuHiddneIndex = navbarTypes.findIndex(t => t.value === 'hidden')
      delete navbarTypes[menuHiddneIndex]
    }

    // Perfect Scrollbar
    const perfectScrollbarSettings = {
      maxScrollbarLength: 60,
      wheelPropagation: false,
    }

    return {
      // Vertical Menu
      isVerticalMenuCollapsed,

      // Customizer
      isCustomizerOpen,

      // Skin
      skin,
      skinOptions,

      // Content Width
      contentWidth,
      contentWidthOptions,

      // RTL
      isRTL,

      // routerTransition
      routerTransition,
      routerTransitionOptions,

      // Layout Type
      layoutType,
      layoutTypeOptions,

      // NavMenu Hidden
      isNavMenuHidden,

      // Navbar
      navbarColors,
      navbarTypes,
      navbarBackgroundColor,
      navbarType,

      // Footer
      footerTypes,
      footerType,

      // Perfect Scrollbar
      perfectScrollbarSettings,
    }
  },
}
</script>

<style lang="scss" scoped>
@import '~@core/scss/base/bootstrap-extended/include';
@import '~@core/scss/base/components/variables-dark';

.customizer-section {
  padding: 1.5rem;
    border-bottom: 1px solid #ebe9f1;

  .dark-layout & {
    border-color: $theme-dark-border-color;
  }

  #skin-radio-group ::v-deep {
    .custom-control-inline {
      margin-right: 0.7rem;
    }
  }

  .form-group {
    margin-bottom: 1.5rem;;
    &:last-of-type {
    margin-bottom: 0;
    }
    ::v-deep legend {
      font-weight: 500;
    }
  }
}

.mark-active {
  box-shadow: 0 0 0 0.2rem rgba(38,143,255,.5);
}

.ps-customizer-area {
  height: calc(100% - 83px)
}
</style>
